import api from "./index";
import esupplyvetApi from "./esupplyvet";

/**
 * Récupère les bannières selon le rôle utilisateur
 * @param {string} userRole - Le rôle de l'utilisateur ('client' pour eSupplyVet, autres pour SupplyVet)
 * @returns {Promise} Réponse de l'API avec les bannières
 */
export function getBanners(userRole = null) {
  const apiInstance = userRole === "client" ? esupplyvetApi : api;

  return apiInstance.get("/banners");
}

/**
 * Récupère une bannière spécifique selon le rôle utilisateur
 * @param {number} id - ID de la bannière
 * @param {string} userRole - Le rôle de l'utilisateur
 * @returns {Promise} Réponse de l'API avec la bannière
 */
export function getBanner(id, userRole = null) {
  const apiInstance = userRole === "client" ? esupplyvetApi : api;

  return apiInstance.get(`/banners/${id}`);
}
